import "./SystemUserInfo.css";
import useUserInfo from "./useUserInfo";
import { getTranslatedText as translate } from "../../Localization/Translation";

const SystemUserInfo = () => {
  const {
    locale,
    eyeNewPassword,
    eyeOldPassword,
    eyeConfirmPassword,
    passwordNewType,
    passwordOldType,
    passwordConfirmType,
    UserNameError,
    PhoneNumberError,
    PasswordError,
    ConfirmPasswordError,
    Eye,
    onChangeInput,
    checkInput,
  } = useUserInfo();

  return (
    <div className="System-UserInfo-component">
      <form>
        <div className="mb-3 animate__animated animate__fadeInLeft">
          <label htmlFor="system-user-name-change-label" className="form-label">
            {translate("system-user-name-change-label", locale)}
          </label>
          <input
            type="text"
            className="form-control"
            id="system-user-name-change-label"
            onChange={(event) =>
              onChangeInput(event, "system-user-name-change-label")
            }
          />
          <div className="invalid-feedback">
            {translate(UserNameError, locale)}
          </div>
        </div>
        <div className="mb-3 animate__animated animate__fadeInLeft animate__delay-1s">
          <label htmlFor="system-phone-change-label" className="form-label">
            {translate("system-phone-change-label", locale)}
          </label>
          <input
            type="text"
            className="form-control"
            id="system-phone-change-label"
            onChange={(event) =>
              onChangeInput(event, "system-phone-change-label")
            }
          />
          <div className="invalid-feedback">
            {translate(PhoneNumberError, locale)}
          </div>
        </div>
        <div className="mb-3 animate__animated animate__fadeInLeft animate__delay-2s">
          <label
            htmlFor="system-old-password-change-label"
            className="form-label"
          >
            {translate("system-old-password-change-label", locale)}
          </label>
          <div className="input-group">
            <input
              type={passwordOldType}
              className="form-control"
              id="system-old-password-change-label"
              onChange={(event) =>
                onChangeInput(event, "system-old-password-change-label")
              }
            />
            <div className="input-group-append">
              <i
                onClick={() => Eye(0)}
                className={`input-group-text eye-pass bi ${
                  eyeOldPassword ? "bi-eye-slash" : "bi-eye"
                }`}
              ></i>
            </div>
            <div className="invalid-feedback">
              {translate(PasswordError, locale)}
            </div>
          </div>
        </div>
        <div className="mb-3 animate__animated animate__fadeInLeft animate__delay-3s">
          <label htmlFor="system-password-change-label" className="form-label">
            {translate("system-password-change-label", locale)}
          </label>
          <div className="input-group">
            <input
              type={passwordNewType}
              className="form-control"
              id="system-password-change-label"
              onChange={(event) =>
                onChangeInput(event, "system-password-change-label")
              }
            />
            <div className="input-group-append">
              <i
                onClick={() => Eye(1)}
                className={`input-group-text eye-pass bi ${
                  eyeNewPassword ? "bi-eye-slash" : "bi-eye"
                }`}
              ></i>
            </div>
            <div className="invalid-feedback">
              {translate(PasswordError, locale)}
            </div>
          </div>
        </div>
        <div className="mb-3 animate__animated animate__fadeInLeft animate__delay-4s">
          <label
            htmlFor="system-confirm-password-change-label"
            className="form-label"
          >
            {translate("system-confirm-password-change-label", locale)}
          </label>
          <div className="input-group">
            <input
              type={passwordConfirmType}
              className="form-control"
              id="system-confirm-password-change-label"
              onChange={(event) =>
                onChangeInput(event, "system-confirm-password-change-label")
              }
            />
            <div className="input-group-append">
              <i
                onClick={() => Eye(2)}
                className={`input-group-text eye-pass bi ${
                  eyeConfirmPassword ? "bi-eye-slash" : "bi-eye"
                }`}
              ></i>
            </div>
            <div className="invalid-feedback">
              {translate(ConfirmPasswordError, locale)}
            </div>
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-primary animate__animated animate__fadeInLeft animate__delay-5s"
          onClick={checkInput}
        >
          {translate("system-password-btn-change-label", locale)}
        </button>
      </form>
    </div>
  );
};

export default SystemUserInfo;
